module.exports = __webpack_public_path__ + "img/lens-167-plus-07.fed50bbe.png";